import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";

import apiService from "../../api/api.service";
import telematicsService from "../../api/telematics.service";
import ApexCharts from "apexcharts";
import rules from "../../utils/rules";
import app from "@/utils/app.json";
import config from "../../../secrets/config";

export default {
  name: "utilization-report",
  components: { pageheader },
  data() {
    return {
      configdata: config.ENABLE_ACCESS_CODE,
      timeframesList: app.timeframelist,
      monthlyListDropDown: app.monthlylistdropdown,
      selectMonthlyDay: null,
      usersList: [],
      isLoaderUser: false,
      selectedUser: "",
      scheduledtimeframe: "",
      selected: [
        "Dates",
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Access Control Codes",
        "Owner Type",
        "Search Field",
      ],
      // Zone is renamed as Geofence
      filterTypes: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Equipment" },
        { id: "4", name: "Geofence" },
        { id: "5", name: "Group" },
        { id: "6", name: "Jobsite" },
        { id: "7", name: "Model" },
        { id: "8", name: "Access Control Codes" },
        { id: "9", name: "Owner Type" },
        { id: "10", name: "Search Field" },
      ],
      filterTypesWithoutAccess: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Equipment" },
        { id: "4", name: "Geofence" },
        { id: "5", name: "Group" },
        { id: "6", name: "Jobsite" },
        { id: "7", name: "Model" },
        { id: "9", name: "Owner Type" },
        { id: "10", name: "Search Field" },
      ],
      selectedOwnershipType: ["1", "2"],
      selectedOwnershipFinal: "",
      ownershipTypes: [
        { name: "Equipment on rent", value: "1" },
        { name: "Assets", value: "2" },
      ],
      selectedZonesNames: [],
      selectedJobSiteNames: [],
      selectedModelNames: [],
      selectedAccessControlCodesNames: [],
      searchMenu: false,
      dailyUtilizationTarget: 0,
      timeList: [{ name: "Hours" }, { name: "Minutes" }],
      selectedTime: "Hours",
      timeSearchFilter: "",
      selectedGroup: [],
      selectedGroupCount: "",
      groups: [],
      selectedMachine: [],
      selectedMachineCount: "",
      machines: [],
      menu1: false,
      menu2: false,
      fromDate: "",
      toDate: "",
      valid: true,
      closeOnContentClick: false,
      groupSearchFilter: "",
      nodataMachine: false,
      showmachinmsg: true,
      machineSearchFilter: null,
      locationMenu: false,
      selectedLocation: "",
      selectedLocationCount: "",
      locations: [],
      loadinglocations: false,
      selectedModel: [],
      selectedModelCount: "",
      modelSearchFilter: "",
      models: [],
      loadingmodel: false,
      //access
      selectedAccessControlCodes: [],
      selectedAccessControlCodesCount: "",
      accessControlCodesSearchFilter: "",
      accessControlCodes: [],
      loadingaccesscontrolcodes: false,
      //end
      zonesList: [],
      selectedZone: [],
      zoneSearchFilter: "",
      menufilter: false,
      selectedJobSite: [],
      //end report filters
      rules: rules,
      input: {},
      searchField: "",
      series: [],
      search: "",
      isDownloading: false,
      loading: false,
      expanded: [],
      excelList: [],
      show1: false,
      isReportLoading: false,
      isReportExporting: false,

      pdfchartBase64: "",
      selectedExportOption: null,

      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            var toHHMMSS = (secs) => {
              var sec_num = parseInt(secs, 10);
              var hours = Math.floor(sec_num / 3600);
              var minutes = Math.floor(sec_num / 60) % 60;
              var seconds = sec_num % 60;

              return [hours, minutes, seconds]
                .map((v) => (v < 10 ? "0" + v : v))
                .filter((v, i) => v !== "00" || i > 0)
                .join(":");
            };
            return toHHMMSS(opts.w.config.series[opts.seriesIndex]);
          },
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: true,
          style: {
            fontWeight: 600,
            fontFamily:
              "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
            fontSize: "14px",
          },
          custom: ({ seriesIndex, w }) => {
            var toHHMMSS = (secs) => {
              var sec_num = parseInt(secs, 10);
              var hours = Math.floor(sec_num / 3600);
              var minutes = Math.floor(sec_num / 60) % 60;
              var seconds = sec_num % 60;

              return [hours, minutes, seconds]
                .map((v) => (v < 10 ? "0" + v : v))
                .filter((v, i) => v !== "00" || i > 0)
                .join(":");
            };
            let className = "series-" + seriesIndex;
            return (
              "<div class='arrow_box " +
              className +
              "'>" +
              "<span>" +
              w.globals.labels[seriesIndex] +
              " : " +
              toHHMMSS(w.config.series[seriesIndex]) +
              "</span>" +
              "</div>"
            );
          },
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            expandOnClick: true,
            dataLabels: {
              offset: 40,
              minAngleToShowLabel: 30,
            },
            donut: {
              size: "5%",
              labels: {
                show: false,
                value: {
                  fontWeight: 600,
                  fontFamily:
                    "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
                  fontSize: "14px",
                },
              },
            },
          },
        },
        responsive: [
          {
            options: {
              chart: {
                width: 380,
              },
            },
          },
        ],
        legend: {
          position: "center",
          show: true,
          horizontalAlign: "center",
          verticalAlign: "center",
          fontWeight: 600,
          fontFamily:
            "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
          fontSize: "14px",
          offsetY: 90,
          offsetX: 20,
        },
        colors: ["#6495ed", "#cd5c5c", "#3cb371"],
        labels: ["Input 1 (Hours)", "Input 2 (Ignition)", "Driving"],
      },
      columnSeries: [],
      utilizationCategories: [],

      exportOptions: ["Excel", "PDF"],
      exporting: false,
      totalheader: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "unitName" },
        { text: "Equipment", value: "stockName" },
        { text: "Telematics SN", value: "telematicsSN" },
        { text: "Timeframe Span of Usage", value: "workDayHoursSum" },
        { text: "Total Active Hours", value: "operationalHoursSum" },
        {
          text: "Utilization Percentage ",
          value: "utilizationPercentage",
        },
        { text: "Low RPM", value: "lowRPM" },

        {
          text: "High RPM / Active Op Hours",
          value: "workingHoursSum",
        },
        {
          text: "Lite/Idle Activity Hours",
          value: "idleHoursSum",
        },
      ],
      operationalheaders: [
        { text: "Date", value: "dateTime", width: "10px" },
        { text: "Work Day Hours", value: "workDayHours", width: "10px" },
        {
          text: "Total Active Hours",
          value: "operationalHours",
          width: "10px",
        },
        {
          text: "High RPM / Active Op Hours",
          value: "workingHours",
          width: "10px",
        },
        {
          text: "Lite/Idle Activity Hours",
          value: "idleHours",
          width: "10px",
        },
      ],
      total: [],
      reportDataList: [],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      jobSiteSearchFilter: "",
      dateCheck: false,
      dateErrorMsg: "",
      filterValidation: false,
      searchContractId: "",

      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },

        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",

      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "UTILWDTREPORT",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      selectedcust: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      // end scheduled reports data fields
    };
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    emails(val, prev) {
      if (val.length === prev.length) return;
      this.emails = val.map((v) => {
        return v;
      });
    },
  },
  computed: {
    ...mapGetters(["roles", "companyIdDropdown", "companyNameDropdown"]),
    columnOptions: function () {
      return {
        chart: {
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        legend: {
          show: true,
          horizontalAlign: "center",
        },
        colors: ["#E91E63", "#3cb371", "#9C27B0"],
        plotOptions: {
          bar: {
            columnWidth: "40%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          labels: {
            rotate: -45,
            style: {
              fontSize: "12px",
              horizontalAlign: "left",
            },
          },

          categories: this.utilizationCategories,
        },
        yaxis: {
          showAlways: true,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
      };
    },
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.reportDataList.length
        : (this.pageNumber - 1) * this.pageSize + this.reportDataList.length;
    },
  },
  mounted() {
    this.input = utils.getInputContent("utilizationReport", this.roles);
    this.getGroups();
    this.getLocations();
    this.getModels();
    this.getZones();
    this.getAccessControlCodes();
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        let date = value.split("T")[0];
        return moment(date).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  methods: {
    clickRow(item, event) {
      if (this.roles != "Customer") {
        if (event.isExpanded) {
          const index = this.expanded.findIndex((i) => i === item);
          this.expanded.splice(index, 1);
        } else {
          this.expanded.push(item);
        }
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1))
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    expandAll() {
      this.$data.expanded = this.$data.reportDataList;
    },
    collapseAll() {
      this.$data.expanded = [];
    },
    joinOrEmpty(list, encode = false) {
      if (list.length > 0) {
        const value = list.join(",");
        return encode ? encodeURIComponent(value) : value;
      }
      return "";
    },
    computeOwnershipFinal(ownershipType) {
      return ownershipType.length == 0 || ownershipType.length == 2
        ? "0"
        : ownershipType[0];
    },
    triggerDownload(response, fileName, mimeType) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: mimeType })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      // deferred a tick: revoking in the same tick as click() can abort the
      // download in Firefox and Safari
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      this.isDownloading = false;
    },
    async readReportListFromAPI() {
      this.reportDataList = [];
      this.isReportLoading = true;
      let date1 = "";
      let date2 = "";
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;
      date1 = this.fromDate;
      date2 = this.toDate;

      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let pageNumber;
      if (this.filterValidation) {
        pageNumber = this.pageNumber;
      } else {
        this.pageNumber = 1;
        pageNumber = this.pageNumber;
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      this.series = [];
      try {
        let response = await telematicsService.getUtilizationReportList(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          this.selectedTime,
          Number(this.dailyUtilizationTarget),
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue,
          pageNumber,
          this.pageSize
        );
        if (response.isSuccess) {
          this.isReportLoading = false;
          this.show1 = true;
          this.reportDataList = response.data.unitTelematics.map(
            (d, index) => ({
              ...d,
              sno: index + 1,
              equipmentStock:
                d.stockName != null && d.stockName != ""
                  ? d.unitName + " (" + d.stockName + ") "
                  : d.unitName,
            })
          );
          this.expanded = [];
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
          //Summary Graph Array Preparation
          this.columnSeries = [];
          let graphArray = [];
          graphArray = response.data.summary;

          let graphObj2 = {};
          graphObj2["name"] =
            "Operational Hours Summary = Hours where machines engine is on";
          graphObj2["data"] = graphArray.map(
            (item) => item.operationalHoursSummary
          );

          let graphObj3 = {};
          graphObj3["name"] =
            "Work Day Hours Summary = Hours when the equipment was being used, thus the first and last activity registered throughout the day ";
          graphObj3["data"] = graphArray.map(
            (item) => item.workDayHoursSummary
          );
          let graphObj4 = {};
          graphObj4["name"] =
            "Working Hours Summary = When a equipment is operated productively ";
          graphObj4["data"] = graphArray.map(
            (item) => item.workingHoursSummary
          );
          this.utilizationCategories = graphArray.map((item) => item.dateTime);
          this.columnSeries.push(graphObj3);
          this.columnSeries.push(graphObj2);

          this.columnSeries.push(graphObj4);
        } else {
          this.isReportLoading = false;
          this.reportDataList = [];
          this.columnSeries = [];
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    async readUsersFromAPI() {
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      try {
        let usersListRes;
        this.isLoaderUser = true;
        if (customerId == "") {
          usersListRes = await apiService.getUsersAll();
        } else {
          usersListRes = await apiService.getUsersByCustId(customerId);
        }
        if (usersListRes) {
          this.isLoaderUser = false;
          this.usersList = usersListRes.data.map((d, index) => ({
            ...d,
            name: d.firstName + " " + d.lastName,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the users" + err);
        this.isLoaderUser = false;
      }
    },
    pageChange() {
      this.readReportListFromAPI();
    },
    async readReportListFromAPIExport() {
      this.isDownloading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;
      date1 = this.fromDate;
      date2 = this.toDate;
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      try {
        let response = await telematicsService.getutilizationReportExport(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          this.selectedTime,
          Number(this.dailyUtilizationTarget),
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFile(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    async readReportListFromApiPdf() {
      this.isDownloading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;
      date1 = this.fromDate;
      date2 = this.toDate;
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      try {
        let response = await telematicsService.getUtilizationReportListPDF(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          this.selectedTime,
          Number(this.dailyUtilizationTarget),
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFilePDF(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    downloadFilePDF(apiResult) {
      if (apiResult) {
        this.triggerDownload(
          apiResult,
          "Utilization Report Detailed.pdf",
          "application/pdf"
        );
      } else {
        this.isDownloading = false;
      }
    },
    downloadFile(response) {
      this.triggerDownload(
        response,
        "Utilization Report Detailed.xlsx",
        "application/vnd.ms-excel"
      );
    },
    filterData() {
      this.reportDataList = [];
      this.series = [];
      this.readReportListFromAPI();
    },
    clearSearch() {
      this.searchField = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    async downloadPdf() {
      this.isDownloading = true;
      var pdfchart = {
        chart: {
          type: "bar",
          height: "350",
          width: "1000",
        },
        dataLabels: {
          enabled: false,
          offsetY: -20,
          offsetX: 0,

          formatter: function (val) {
            return val.toFixed(0);
          },
          style: {
            fontWeight: 600,
            fontFamily:
              "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
            fontSize: "12px",
            colors: ["#333"],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
            style: {
              fontSize: "12px",
              horizontalAlign: "left",
            },
          },
          categories: this.utilizationCategories,
        },
        yaxis: {
          showAlways: true,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        legend: {
          position: "bottom",
          width: "1000",
          show: true,
          horizontalAlign: "center",
          verticalAlign: "center",
          fontFamily:
            "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
          fontSize: "10px",
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            dataLabels: {
              position: "top",
              orientation: "horizontal",
            },
          },
        },
        colors: ["#E91E63", "#3cb371", "#9C27B0"],
        series: this.columnSeries,
        labels: [
          "Operational Hours Summary = Hours where machines engine is on",
          "Work Day Hours Summary = Hours when the machine was being used, thus the first and last activity registered throughout the day",
          "Working Hours Summary = When a machine is operated productively ",
        ],
      };

      this.$refs.pdfchart.hidden = false;
      let div = document.getElementById("pdfchart");
      div.replaceChildren();
      var chart1 = new ApexCharts(
        document.querySelector("#pdfchart"),
        pdfchart
      );
      let th = this;
      th.pdfchartBase64 = "";
      try {
        chart1.destroy();
      } catch {
        // chart may not be initialized yet — safe to ignore
      }
      let div1 = document.getElementById("pdfchart");
      div1.replaceChildren();
      chart1 = new ApexCharts(document.querySelector("#pdfchart"), pdfchart);

      chart1.render().then(() => {
        window.setTimeout(function () {
          chart1.dataURI().then((uri) => {
            th.pdfchartBase64 = uri;
            th.downloadDocument();
          });
        }, 4000);
      });
    },
    async downloadDocument() {
      let date1 = "";
      let date2 = "";
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;
      date1 = this.fromDate;
      date2 = this.toDate;
      machineIds = this.joinOrEmpty(this.selectedMachine);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      let payload = {
        fromDate: date1,
        toDate: date2,
        summaryDetails: this.pdfchartBase64.imgURI.replace(
          "data:image/png;base64,",
          ""
        ),
        machineIds: machineIds,
        groupIds: groupIds,
        model: model,
        jobsite: jobSite,
        zone: zone,
        ownerType: "All",
        searchKey: searchValue,
        accessCodes: accessControlCodes,
        contractId: searchContractValue,
        utilizationTargetType: this.selectedTime,
        utilizationTargetValue: Number(this.dailyUtilizationTarget),
      };
      try {
        let apiResult = await telematicsService.getUtilizationPDF(payload);
        if (apiResult) {
          const url = window.URL.createObjectURL(
            new Blob([apiResult], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Utilization Report Detailed.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          // deferred a tick: revoking in the same tick as click() can abort the
          // download in Firefox and Safari
          setTimeout(() => window.URL.revokeObjectURL(url), 0);

          this.$refs.pdfchart.hidden = false;
          this.isDownloading = false;
        } else {
          this.isDownloading = false;
          this.$toast.error(apiResult.systemMessage);
        }
      } catch (err) {
        this.$refs.pdfchart.hidden = true;
        this.isDownloading = false;
        this.$toast.error("Unable to download the report" + err);
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.readReportListFromAPIExport();
        }
        //case  "Pdf"
        else if (this.selectedExportOption == this.exportOptions[1]) {
          this.downloadPdf();
        }
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    //All Report Filter Methods
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnewrent(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getAccessControlCodes() {
      try {
        this.loadingaccesscontrolcodes = true;
        let owrtype, id;
        let cust;
        if (
          this.companyIdDropdown == "" ||
          this.companyIdDropdown == null ||
          this.companyIdDropdown == undefined
        ) {
          cust = "All";
          id = "";
        } else {
          cust = this.$store.getters.companyNameDropdown;
          id = this.$store.getters.companyIdDropdown;
        }
        if (cust == "All") {
          owrtype = "1";
        } else {
          owrtype = "2";
        }
        let response = await telematicsService.getAccessKeysList(id, owrtype);
        if (response) {
          this.accessControlCodes = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              accesscontrolcode: String(index),
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });

          this.loadingaccesscontrolcodes = false;
        }
      } catch (err) {
        this.loadingaccesscontrolcodes = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
      this.dateErrorMsg = "";
    },
    resetGroup() {
      (this.selectedGroup = []), (this.reportDataList = []);
      this.series = [];
    },
    resetMachine() {
      (this.selectedMachine = []), (this.reportDataList = []);
      this.series = [];
    },
    resetZone() {
      this.selectedZone = [];
      this.selectedZonesNames = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
    },
    resetModel() {
      this.selectedModel = [];
      this.selectedModelNames = [];
    },
    resetAccessControlCodes() {
      this.selectedAccessControlCodes = [];
      this.selectedAccessControlCodesNames = [];
    },
    clearFilters() {
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
      this.fromDate = "";
      this.toDate = "";
      this.reportDataList = [];
      this.series = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.searchField = "";
      this.selectedTime = "Hours";
      this.dailyUtilizationTarget = 0;
      this.selectedZonesNames = [];
      this.selectedJobSiteNames = [];
      this.selectedModelNames = [];
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodes = [];
      this.dateErrorMsg = "";
      this.filterValidation = false;
      this.searchContractId = "";
      this.readReportListFromAPI();
    },
    //End All Report Filter Methods
    resetUtilizationTarget() {
      this.dailyUtilizationTarget = 0;
    },
    resetTimeSlot() {
      this.selectedTime = "Hours";
    },
    OnOwnerTypeChange() {
      this.selectedOwnershipFinal = this.computeOwnershipFinal(
        this.selectedOwnershipType
      );
    },
    resetOwnerType() {
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    accessControlCodeChange() {
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodesNames =
        this.selectedAccessControlCodes.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },

    datesCompare() {
      if (this.fromDate && this.toDate) {
        let dateCheck =
          moment(this.toDate).format("YYYY-MM-DD") >=
          moment(this.fromDate).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;
        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
        }
      }
    },
    // scheduled reports api calls

    clearTimeFrame() {
      this.scheduledtimeframe = "";
    },
    OnOwnerTypeChangeSchedule() {
      this.selectedOwnershipFinalSchedule = this.computeOwnershipFinal(
        this.selectedOwnershipTypeSchedule
      );
    },

    resetOwnerTypeSchedule() {
      this.selectedOwnershipTypeSchedule = ["1", "2"];
      this.selectedOwnershipFinalSchedule = "0";
    },
    zoneChangeSchedule() {
      this.selectedZonesNamesSchedule = [];
      this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    jobSiteChangeSchedule() {
      this.selectedJobSiteNamesSchedule = [];
      this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    modelChangeSchedule() {
      this.selectedModelNamesSchedule = [];
      this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    accessControlCodeChangeSchedule() {
      this.selectedAccessControlCodesNamesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule =
        this.selectedAccessControlCodesSchedule.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },

    resetGroupSchedule() {
      this.selectedGroupSchedule = [];
    },

    resetZoneSchedule() {
      this.selectedZoneSchedule = [];
      this.selectedZonesNamesSchedule = [];
    },
    resetMachineSchedule() {
      this.selectedMachineSchedule = [];
    },
    resetJobSiteSchedule() {
      this.selectedJobSiteSchedule = [];

      this.selectedJobSiteNamesSchedule = [];
    },
    resetAccessControlCodesSchedule() {
      this.selectedAccessControlCodesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule = [];
    },
    resetModelSchedule() {
      this.selectedModelSchedule = [];
      this.selectedModelNamesSchedule = [];
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.scheduleedit = false;
      this.clearSchedule();
      this.readUsersFromAPI();
      this.displayScheduledForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;
      this.selectMonthlyDay = null;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";
      this.selectedOwnershipTypeSchedule = ["1", "2"];
      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetMachineSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.selectedUser = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";
      this.selectMonthlyDay = null;

      this.selectedOwnershipTypeSchedule = ["1", "2"];
      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetMachineSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    openScheduledDialog() {
      this.displayScheduledForm = false;
      this.scheduledialog = true;

      this.getScheduledList();
    },
    EditScheduleDialog(item) {
      this.scheduleedit = true;
      let dataser = "";
      this.searchMachines(dataser);
      this.selectedschedule = item;

      this.readUsersFromAPI();
      this.scheduleName = item.name;
      this.selectedcust = item.customerName;

      this.selectedUser = item.requestUserId;
      this.emails = item.emails.split(",");
      this.selectedDays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.selectMonthlyDay =
        item.day != null && item.day != "" ? item.day : null;

      this.scheduledFrequency = item.frequency;
      this.scheduledtimeframe = item.timeFrame;
      this.scheduledType = item.format;
      this.displayScheduledForm = true;
      // filters

      item.parameters.filter((e) => {
        if (e.name == "machineIds" && e.value != "") {
          this.machineSearchFilterSchedule = e.value;

          this.selectedMachineSchedule = e.value.split(",");
        }
        if (e.name == "groupIds" && e.value != "") {
          this.selectedGroupSchedule = e.value.split(",");
        }
        if (e.name == "zone" && e.value != "") {
          this.selectedZoneSchedule = e.value.split(",");
          this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
            (id) => this.zonesList.find((el) => el.id == id).name
          );
        }
        if (e.name == "model" && e.value != "") {
          this.selectedModelSchedule = e.value.split(",");
          this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
            (id) => this.models.find((el) => el.id == id).name
          );
        }
        if (e.name == "jobSite" && e.value != "") {
          this.selectedJobSiteSchedule = e.value.split(",");
          this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
            (locationId) =>
              this.locations.find((el) => el.locationId == locationId)
                .locationName
          );
        }
        if (e.name == "utilizationTargetValue" && e.value != "") {
          this.dailyUtilizationTargetSchedule = e.value;
        }
        if (e.name == "accessCodes" && e.value != "") {
          this.selectedAccessControlCodesSchedule = e.value.split(",");
          this.selectedAccessControlCodesNamesSchedule =
            this.selectedAccessControlCodesSchedule.map(
              (serialNumber) =>
                this.accessControlCodes.find(
                  (el) => el.serialNumber == serialNumber
                ).showCodeName
            );
        }
        if (e.name == "ownerType" && e.value != "") {
          if (e.value == "0") {
            this.selectedOwnershipTypeSchedule = ["1", "2"];
          } else {
            this.selectedOwnershipTypeSchedule = [e.value];
          }
          this.selectedOwnershipFinalSchedule = this.computeOwnershipFinal(
            this.selectedOwnershipTypeSchedule
          );
        }
        if (e.name == "utilizationTargetType" && e.value != "") {
          this.selectedTimeSchedule = e.value;
        }
        if (e.name == "searchKey" && e.value != "") {
          this.searchFieldSchedule = e.value;
        }
        if (e.name == "contractId" && e.value != "") {
          this.searchContractIdSchedule = e.value;
        }
      });

      //end filters
    },
    async CreateSchedule() {
      this.isSaveScheduleLoading = true;
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;

      machineIds = this.joinOrEmpty(this.selectedMachineSchedule);
      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }

      this.selectedOwnershipFinalSchedule = this.computeOwnershipFinal(
        this.selectedOwnershipTypeSchedule
      );
      let parameters = [
        {
          name: "machineIds",
          value: machineIds,
        },
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "utilizationTargetValue",
          value: String(this.dailyUtilizationTargetSchedule),
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "ownerType",
          value: this.selectedOwnershipFinalSchedule,
        },
        {
          name: "utilizationTargetType",
          value: this.selectedTimeSchedule,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: cust,
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,

        format: this.scheduledType,
        timeframe: this.scheduledtimeframe,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };

      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveScheduleLoading = false;
          this.$toast.success(" Schedule report  created successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isSaveScheduleLoading = false;
          this.reportDataList = [];
          this.columnSeries = [];
        }
      } catch (err) {
        console.log(err);
        this.isSaveScheduleLoading = false;
      }
    },
    async UpdateSchedule() {
      this.isupdateScheduleLoading = true;
      let machineIds, zone, groupIds, jobSite, model, accessControlCodes;

      machineIds = this.joinOrEmpty(this.selectedMachineSchedule);
      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      this.series = [];
      this.selectedOwnershipFinalSchedule = this.computeOwnershipFinal(
        this.selectedOwnershipTypeSchedule
      );
      let parameters = [
        {
          name: "machineIds",
          value: machineIds,
        },
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "utilizationTargetValue",
          value: String(this.dailyUtilizationTargetSchedule),
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "ownerType",
          value: this.selectedOwnershipFinalSchedule,
        },
        {
          name: "utilizationTargetType",
          value: this.selectedTimeSchedule,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        id: this.selectedschedule.id,
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: this.selectedcust,
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        timeframe: this.scheduledtimeframe,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };

      try {
        let response = await telematicsService.updateScheduledReport(
          this.selectedschedule.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateScheduleLoading = false;
          this.$toast.success(" Schedule report  updated successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isupdateScheduleLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isupdateScheduleLoading = false;
      }
    },

    async getScheduledList() {
      this.isScheduledListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.ScheduleReportName)
        );

        if (response.isSuccess) {
          this.isScheduledListLoading = false;
          this.scheduledList = response.data;
        } else {
          this.isScheduledListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isScheduledListLoading = false;
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedschedule = item;
    },
    async deleteSchedule() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteSchedule(
          this.selectedschedule.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearSchedule();
          this.displayScheduledForm = false;
          this.getScheduledList();
          this.confirmdialog = false;
          this.selectedschedule = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    OnFrequencyChange() {
      this.selectedDays = [];
      this.selectMonthlyDay = null;
    },
    // end scheduled reports methods
  },
};
